import { BRSR_METHODOLOGY_VERSION, BRSR_SESSION_STORAGE_ENABLED, BRSR_SESSION_STORAGE_KEY } from '../../config/brsrConfig'
import { REGULATORY_CONFIG_VERSION } from '../../data/brsr/regulatoryRules'
import type { BrsrState } from '../../data/brsr/types'
import { createInitialBrsrState } from './engine'

export function loadBrsrState(): BrsrState {
  if (!BRSR_SESSION_STORAGE_ENABLED || typeof sessionStorage === 'undefined') return createInitialBrsrState()
  try {
    const raw = sessionStorage.getItem(BRSR_SESSION_STORAGE_KEY)
    if (!raw) return createInitialBrsrState()
    const parsed = JSON.parse(raw) as BrsrState
    if (parsed.methodologyVersion !== BRSR_METHODOLOGY_VERSION) return createInitialBrsrState()
    if (parsed.regulatoryConfigVersion !== REGULATORY_CONFIG_VERSION) return createInitialBrsrState()
    return {
      ...createInitialBrsrState(),
      ...parsed,
      responses: { ...parsed.responses },
    }
  } catch {
    return createInitialBrsrState()
  }
}

export function saveBrsrState(state: BrsrState): void {
  if (!BRSR_SESSION_STORAGE_ENABLED || typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(BRSR_SESSION_STORAGE_KEY, JSON.stringify(state))
  } catch {
    // Private mode or quota. The in-memory session on this page still works.
  }
}

export function clearBrsrState(): void {
  if (typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.removeItem(BRSR_SESSION_STORAGE_KEY)
  } catch {
    // ignore
  }
}
